import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { AuthService } from '@auth';
import { UserProfile, Organization } from 'src/app/shared/models/user-profile';
import { SwitchLanguageService } from 'src/app/core/services/switch-language.service';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuTrigger } from '@angular/material/menu';
import { AllowIn, ShortcutInput } from 'ng-keyboard-shortcuts';
import { KeyboardShortcutsHelpComponent } from '../keyboard-shortcuts-help/keyboard-shortcuts-help.component';
import { OnlineOfflineService } from '../../services/online-offine.service';
import { PagePermissions } from 'src/app/shared/models/permissions';
import { PreviewFeaturesComponent } from '../preview-features/preview-features.component';
import { TranslateService } from '@ngx-translate/core';
import { HelpersService } from '@shared';

@Component({
  selector: 'app-toolbar',
  templateUrl: './tool-bar.component.html',
  styleUrls: ['./tool-bar.component.scss']

})
export class ToolBarComponent implements OnInit, AfterViewInit {
  isSwitchOrganization: boolean = false;
  isPreviewFeatures: boolean = false;
  isSwitchLanguage: boolean = false;
  userProfile?: UserProfile;
  currentOrganization?: Organization;
  userOrganizations: Organization[] = [];
  isExpanded = false;

  shortcuts: ShortcutInput[] = [];

  public get pagePermissions(): typeof PagePermissions {
    return PagePermissions;
  }

  @ViewChild('clickMenuTrigger') clickMenuTrigger!: MatMenuTrigger;
  @ViewChild('changeLanguageTrigger') changeLanguageTrigger!: MatMenuTrigger;

  constructor(
    public authService: AuthService,
    public helpersService: HelpersService,
    public onlineOfflineService: OnlineOfflineService,
    public switchLanguageService: SwitchLanguageService,
    private translateService: TranslateService,
    @Inject(MatDialog) private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.authService.userLoggedIn$.subscribe({
      next: (userProfile: UserProfile) => {
        if (userProfile) {
          this.userProfile = userProfile;
          this.currentOrganization = this.authService.currentOrganization;
        }
      }
    });

    this.authService.tenantSwitched$.subscribe({
      next: () => {
        this.currentOrganization = this.authService.currentOrganization;
      }
    });

    if (this.authService.isAuthenticated()) {
      this.userProfile = this.authService.userProfile;
      this.currentOrganization = this.authService.currentOrganization;
      this.userOrganizations = this.authService.userOrganizations;
    }

  }

  ngAfterViewInit() {
    this.initShortcuts();
  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  closeMenu() {
    this.clickMenuTrigger?.closeMenu();
  }

  logout() {
    this.authService.logout();
  }

  help(): void {
    this.dialog.open(KeyboardShortcutsHelpComponent, {
      width: '950px',
      height: '95vh',
      autoFocus: false,
      restoreFocus: false,
      closeOnNavigation: true
    });
  }

  openPreviewFeaturesDialog() {
    this.dialog.open(PreviewFeaturesComponent, {
      width: '400px',
      height: '95vh',
      autoFocus: false,
      restoreFocus: false,
      closeOnNavigation: true,
      position: this.translateService.currentLang === 'en' ? { top: '0px', right: '14px' } : { top: '0px', left: '14px' },
      panelClass: this.translateService.currentLang === 'en' ? ['previewFeatures_panel', 'animate__animated', 'animate__slideInDown'] :
        ['previewFeatures_panel', 'animate__animated', 'animate__slideInDown']
    });
  }

  initShortcuts() {
    this.shortcuts.push(
      {
        key: ['alt + shift + t'],
        allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
        label: 'Navigation',
        description: 'Switch Tenant',
        command: () => this.openSwitchTenantMenu(),
        preventDefault: true
      },
      {
        key: ['alt + shift + x'],
        allowIn: [AllowIn.Textarea, AllowIn.Input, AllowIn.Select],
        label: 'Navigation',
        description: 'Change Language',
        command: () => this.openChangeLanguageMenu(),
        preventDefault: true
      },
    );
  }

  private openSwitchTenantMenu() {
    this.clickMenuTrigger.openMenu();
    if (!this.isSwitchOrganization) {
      this.showSwitchOrganization();
    }
  }

  private openChangeLanguageMenu() {
    this.clickMenuTrigger.openMenu();
    this.changeLanguageTrigger.openMenu();
  }

  showSwitchOrganization() {
    // Pull the latest list from AuthService each time the view opens, so it reflects orgs that
    // were loaded asynchronously after login (rather than the stale snapshot taken at init).
    this.userOrganizations = this.authService.userOrganizations;
    this.isSwitchOrganization = !this.isSwitchOrganization
  }

  showSwitchLanguage() {
    this.isSwitchLanguage = !this.isSwitchLanguage
  }
  showPreviewFeatures() {
    this.isPreviewFeatures = !this.isPreviewFeatures
  }
  closedMenu() {
    setTimeout(() => {
      this.isSwitchOrganization = false;
      this.isPreviewFeatures = false;
      this.isSwitchLanguage = false;
    }, 100);
  }
}
